@let fieldSubs = fields();
@if (isLoaded() && fieldSubs) {
  <ng-container [formGroup]="responseForm">
    @for (field of fieldSubs; track field) {
      <div class="mb-1">
        <app-custom-form-field
          [formControlName]="field.id"
          [config]="field"
          [locale]="locale()"
          [showErrors]="showErrors()"
          (updated)="propagateFieldUpdate($event)" />
      </div>
    }
  </ng-container>
}
